module.exports = __webpack_public_path__ + "static/img/csss_eng_2.810760cb.jpg";